import { Reveal, Overline } from "./Reveal";
import { SITE } from "../config/site";

export const MeetStaci = () => (
  <section id="meet-staci" data-testid="meet-staci-section" className="relative bg-sage/50 py-24 sm:py-32">
    <div className="mx-auto grid max-w-7xl grid-cols-1 items-center gap-14 px-5 sm:px-8 lg:grid-cols-12">
      <Reveal className="lg:col-span-5">
        <div className="relative mx-auto max-w-sm">
          <div
            aria-hidden="true"
            className="absolute -inset-3 -translate-x-4 translate-y-4 rounded-t-full rounded-b-[2.5rem] border border-forest/20"
          />
          <div className="relative overflow-hidden rounded-t-full rounded-b-[2.5rem] shadow-[0_30px_60px_rgba(23,63,53,0.18)]">
            <img
              src={SITE.images.staciPortrait}
              alt="Staci Freed seated on sunlit rocks beside a flowing river"
              loading="lazy"
              className="aspect-[4/5] w-full object-cover object-left"
            />
          </div>
        </div>
      </Reveal>
      <div className="lg:col-span-7 lg:pl-10">
        <Reveal>
          <Overline>Meet Staci</Overline>
          <h2 className="font-serif text-3xl leading-tight text-forest sm:text-4xl lg:text-5xl">
            A fellow traveller on the path <em className="italic text-gold">home to yourself</em>
          </h2>
        </Reveal>
        <Reveal delay={0.12}>
          <p className="mt-7 text-lg font-light leading-relaxed text-charcoal/75">
            Staci Freed is a holistic wellness and spiritual educator devoted to women and
            mothers who give so much of themselves that their own health quietly slips to the
            bottom of the list.
          </p>
          <p className="mt-5 leading-relaxed text-charcoal/70">
            Her work weaves together natural wellness, conscious living, and honest spiritual
            reflection: never rushed, never clinical, always personal. This space will soon
            hold Staci's full story and philosophy, in her own words.
          </p>
          <p className="mt-8 font-serif text-xl italic text-forest/85">
            "You don't need to become someone new. You need room to return to who you already are."
          </p>
          <p className="mt-3 text-xs uppercase tracking-[0.25em] text-taupe">
            Preliminary copy · Staci's story to come
          </p>
        </Reveal>
      </div>
    </div>
  </section>
);
